// extracted by mini-css-extract-plugin
export default {"flipBtn":"FlipButton_flipBtn__Sh0BJ","flipIcon":"FlipButton_flipIcon__HzM-q"};